import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function PrivateRoute({ children }) {
    const { currentUser, loading } = useAuth();

    if (loading) {
        // Wait for auth check to complete, or the context's !loading check to finish (though context usually handles this)
        // Since AuthProvider already waits for loading to be false before rendering children, we might not need this here
        // BUT if we access this route somehow before context is ready (unlikely), it is safety.
        // However, useContext(AuthContext) will return the context value. 
        // AuthProvider returns children only when !loading is true.
        // So technically currentUser will be accurate.
        // But let's keep it safe.
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-purple-50 to-slate-100 dark:from-slate-900 dark:via-indigo-950 dark:to-slate-900">
                <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
            </div>
        );
    }

    return currentUser ? children : <Navigate to="/login" />;
}
